export enum DifferenceType {
    UpFrom,
    DownFrom,
    NoChange,
    NoDataPrevious
}
